import React, { useEffect } from 'react'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { ScrollSmoother } from 'gsap/ScrollSmoother'

import './DigiHealthLandingWrapper.css'
import DigiHealthLandingHero from './DigiHealthLandingHero/DigiHealthLandingHero'
import DigiHealthLandingMissViss from './DigiHealthLandingMissViss/DigiHealthLandingMissViss'
import DigiHealthLandingService from './DigiHealthLandingService/DigiHealthLandingService'
import DigiHealthLandingGovInd from './DigiHealthLandingGovInd/DigiHealthLandingGovInd'
import DigiHealthLandingContact from './DigiHealthLandingContact/DigiHealthLandingContact'
import DigiHealthLandingFooter from './DigiHealthLandingFooter/DigiHealthLandingFooter'
import DigiHealthLandingNavbar from './DigiHealthLandingNavbar/DigiHealthLandingNavbar'

gsap.registerPlugin(ScrollTrigger, ScrollSmoother)

const DigiHealthLandingWrapper = () => {

  useEffect(() => {
    // Create the smooth scroller
    const smoother = ScrollSmoother.create({
      wrapper: '#smooth-wrapper',
      content: '#smooth-content',
      smooth: 1.5, // Higher value = smoother scrolling
      effects: true, // Enables special scroll effects
      normalizeScroll: true, // Prevents jerky scrolling on some devices
      ignoreMobileResize: true, // Helps with mobile performance
    })

    // Clean up on component unmount
    return () => {
      smoother.kill()
      // Kill all ScrollTriggers to prevent memory leaks
      ScrollTrigger.getAll().forEach(trigger => trigger.kill())
    }
  }, [])


  return (
    <>
    <div id='smooth-wrapper'>
      <div id='smooth-content'>

        <DigiHealthLandingNavbar/>


        <section id='home'>
          <DigiHealthLandingHero/>
        </section>

        <section id='about'>
          <DigiHealthLandingMissViss/>
        </section>

        <section id='collaboration'>
          <DigiHealthLandingService/>
        </section>

        <section id='research'>
          <DigiHealthLandingGovInd/>
        </section>

        <section id='contact'>
          <DigiHealthLandingContact/>
        </section>

        <DigiHealthLandingFooter/>

      </div>
    </div>
    </>
  )
}

export default DigiHealthLandingWrapper
